import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  LucideAngularModule,
  Tv,
  Globe,
  Mountain,
  Train,
  Video,
  Package,
  Utensils,
  Droplet
} from 'lucide-angular';
import { TranslocoModule } from '@jsverse/transloco';
import { TooltipModule } from 'primeng/tooltip';
import { AdemeEquivalence, ImpactCo2Meta } from '../../models/ademe-equivalence';

@Component({
  selector: 'app-ademe-equivalences',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    TranslocoModule,
    TooltipModule
  ],
  templateUrl: './ademe-equivalences.component.html'
})
export class AdemeEquivalencesComponent {
  @Input() equivalences: AdemeEquivalence[] = [];
  @Input() meta!: ImpactCo2Meta;

  getIcon(slug: string): typeof Tv {
    const iconMap: Record<string, typeof Tv> = {
      streaming_harry_potter: Tv,
      world_tour_car: Globe,
      ski_days: Mountain,
      paris_berlin_train: Train,
      videoconference_hours: Video,
      home_delivery: Package,
      chicken_meal: Utensils,
      tap_water_liters: Droplet
    };
    return iconMap[slug] || Globe;
  }

  isLessThanOne(value: number | '<1'): boolean {
    return value === '<1';
  }
}
